import { useMutation } from "@tanstack/react-query";
import { activeESim } from "../repositories/esim.repository";

export const useActiveESim = () => {
  return useMutation({
    mutationFn: (msisdn: string) => activeESim(msisdn),
    onSuccess: (data) => {
      console.log("🎯 Active eSim successful:", data);
    },
    onError: (error) => {
      console.error("💥 Active eSim failed:", error);
    },
  });
};
